import { axiosRequestHandler } from '../../../helpers/apiHelper';

export const FetchProjectsAPI = async (requestParameter) => {
  try {
    return await axiosRequestHandler('projects?include=jobWalkPerformance', 'get');
  } catch (error) {
    throw new Error({ error: true, message: 'Something went wrong..!!' });
  }
};

export const UpdateProjectAPI = async (data) => {
  try {
    return await axiosRequestHandler(`projects/${data.id}`, 'put', data);
  } catch (error) {
    throw new Error({ error: true, message: 'Something went wrong..!!' });
  }
};

export const CreateProjectAPI = async (data) => {
  try {
    return await axiosRequestHandler('projects', 'post', data);
  } catch (error) {
    throw new Error({ error: true, message: 'Something went wrong..!!' });
  }
};

export const DeleteProjectAPI = async (data) => {
  try {
    return await axiosRequestHandler(`projects/${data.id}`, 'delete');
  } catch (error) {
    throw new Error({ error: true, message: 'Something went wrong..!!' });
  }
};

export const DuplicateProjectAPI = async (data) => {
  try {
    return await axiosRequestHandler(`projects/${data.id}/duplicate`, 'post');
  } catch (error) {
    throw new Error({ error: true, message: 'Something went wrong..!!' });
  }
};

export const GetProjectDetailsAPI = async (data) => {
  try {
    return await axiosRequestHandler(`projects/${data.id}`, 'get');
  } catch (error) {
    throw new Error({ error: true, message: 'Something went wrong..!!' });
  }
};

/**
 * Get project users API
 * @param {Number} projectId - project id
 */
export const fetchProjectUsersAPI = async (projectId) => {
  try {
    return await axiosRequestHandler(`projects/${projectId}/users`, 'get');
  } catch (error) {
    throw new Error({ error: true, message: 'Something went wrong..!!' });
  }
};
/**
 * Get project users API
 * @param {Number} projectId - project id
 */
export const fetchProjectUserPermissionsAPI = async (projectId) => {
  try {
    return await axiosRequestHandler(`projects/${projectId}/permissions`, 'get');
  } catch (error) {
    throw new Error({ error: true, message: 'Something went wrong..!!' });
  }
};

export const UpdatePriorityAPI = async (data) => {
  try {
    if (data.orderingType == 'location') {
      return await axiosRequestHandler(`locations/reorder`, 'post', {
        project_id: data.parentId,
        locations: data.locationIds,
      });
    } else if (data.orderingType == 'zone') {
      return await axiosRequestHandler(`locations/${data.parentId}/zones/reorder`, 'post', {
        zones: data.zoneIds,
      });
    } else if (data.orderingType == 'area') {
      return await axiosRequestHandler(`zones/${data.parentId}/areas/reorder`, 'post', {
        areas: data.areaIds,
      });
    }
  } catch (error) {
    throw new Error({ error: true, message: 'Something went wrong..!!' });
  }
};

/**
 * Update project permissions API
 * @param {Integer} projectId - project id
 * @param {[Object]} permissions - permissions object
 * @param {Integer} permissions[].id - user id
 * @param {String} permissions[].access_level - user's id
 * @param {String} permissions[].project_role - user's project role
 */
export const addPermissionsAPI = async ({ projectId, permissions }) => {
  try {
    return await axiosRequestHandler(`projects/${projectId}/permissions`, 'post', {
      permissions: permissions,
    });
  } catch (error) {
    throw new Error({ error: true, message: 'Something went wrong..!!' });
  }
};

/**
 * Update project permissions API
 * @param {[Object]} permissions - permissions object
 * @param {Integer} permissions[].id - user id
 * @param {String} permissions[].access_level - user's id
 * @param {String} permissions[].project_role - user's project role
 */
export const updatePermissionsAPI = async ({ projectId, permissions }) => {
  try {
    return await axiosRequestHandler(`projects/${projectId}/permissions`, 'patch', {
      permissions: permissions,
    });
  } catch (error) {
    throw new Error({ error: true, message: 'Something went wrong..!!' });
  }
};

/**
 * Delete project permissions API
 * @param {Object} permissions - permissions object
 * @param {Number[]} permissions.project_ids - project ids to delete
 * @param {Number[]} permissions.user_ids - user ids to delete
 */
export const deletePermissionsAPI = async ({ projectId, userIds }) => {
  try {
    return await axiosRequestHandler(`projects/${projectId}/permissions`, 'delete', {
      user_ids: userIds,
    });
  } catch (error) {
    throw new Error({ error: true, message: 'Something went wrong..!!' });
  }
};

/**
 * Update project Kpi
 * @param {String} id - projectId
 */
export const updateProjectKpiAPI = async (id) => {
  try {
    return await axiosRequestHandler(`projects/${id}/kpi`, 'post');
  } catch (error) {
    throw new Error({ error: true, message: 'Something went wrong..!!' });
  }
};
